import { Button } from "@/components/ui/button";
import { PlusIcon } from "lucide-react";
import { useTranslation } from "react-i18next";
import { usePayrollPermissions } from "../hooks/usePayrollPermissions";
import { PayrollCreateEntryDialog } from "./PayrollCreateEntryDialog";

export const PayrollCreateEntryButton = () => {
  const { t } = useTranslation();
  const permissions = usePayrollPermissions();

  return (
    <PayrollCreateEntryDialog>
      <Button variant="outline" disabled={!permissions.canUpdateInspection}>
        <PlusIcon className="w-4 h-4 mr-1" />
        {t("payrolls.views.inspection.createPayrollEntry")}
      </Button>
    </PayrollCreateEntryDialog>
  );
};
